<div class="main-container">
  <div class="left-container">
    <app-login-load></app-login-load>
  </div>
  <div class="right-container bg-white flex justify-content-center align-items-center flex flex-column px-7 ">

    <div class="flex align-self-baseline align-items-center mb-3">
      @if (_auth.appConfig() && _auth.appConfig().parentBrandLogoURL) {
        <div>
          <img [src]="_auth.appConfig().parentBrandLogoURL" alt="logo" class="logo" [style]="{ height:( _auth.appConfig().parentBrandLogoHeightLogin ? _auth.appConfig().parentBrandLogoHeightLogin + 'rem' : '4rem') }"/>
        </div>
        <div class="h-3rem bg-gray-300 mr-1" [style]="{width : '2px'}"></div>
      }
      @if (_auth.appConfig() && _auth.appConfig().brandLogoURL && _auth.appConfig().loginDefaultBrand === 'brandLogoURL') {
        <div>
          <img [src]="_auth.appConfig().brandLogoURL" alt="logo" class="logo" [style]="{ height:( _auth.appConfig().brandLogoHeightLogin ? _auth.appConfig().brandLogoHeightLogin + 'rem' : '4rem') }"/>
        </div>
      }@else if(_auth.appConfig() && _auth.appConfig().brandName && _auth.appConfig().loginDefaultBrand === 'brandName') {
        <div [style]="_auth.appConfig().brandNameStyle">
          {{_auth.appConfig().brandName}}
        </div>
      }@else if(_auth.appConfig() && _auth.appConfig().brandLogoURL && _auth.appConfig().brandName){
        <div>
          <img [src]="_auth.appConfig().brandLogoURL" alt="logo" class="logo" [style]="{ height:( _auth.appConfig().brandLogoHeightLogin ? _auth.appConfig().brandLogoHeightLogin + 'rem' : '4px') }"/>
        </div>
        <div [style]="_auth.appConfig().brandNameStyle">
          {{_auth.appConfig().brandName}}
        </div>
      }
    </div>

    <app-tfa
      [tfaInputData]="_auth.tfaConfig() ? _auth.tfaConfig() : null"
      [isTfaConfigured]="false"
      (loginEvent)="verifyOTP($event)"
    ></app-tfa>
  </div>
</div>
